import { useQuery, gql } from '@apollo/client';

const INTEGRATION_ACTION_FIELDS = gql`
  fragment IntegrationActionFields on IntegrationAction {
    id
    name
    description
    displayLocation
    integrationPackage {
      id
      name
      logoUrl
      iconUrl
    }
  }
`;

const GET_INTEGRATION_ACTIONS = gql`
  query GetIntegrationActions($displayLocation: String = "project-actions") {
    integrationActions(displayLocation: $displayLocation) {
      ...IntegrationActionFields
    }
  }
  ${INTEGRATION_ACTION_FIELDS}
`;

const useGetIntegrationActions = () => {
  const { data, loading: isIntegrationActionsLoading } = useQuery(
    GET_INTEGRATION_ACTIONS,
  );

  const integrationActions = data?.integrationActions ?? [];

  return { integrationActions, isIntegrationActionsLoading };
};

const useGetPhotoIntegrationActions = () => {
  const { data, loading: isPhotoIntegrationActionsLoading } = useQuery(
    GET_INTEGRATION_ACTIONS,
    {
      variables: { displayLocation: 'photo-actions' },
    },
  );

  const photoIntegrationActions = data?.integrationActions ?? [];

  return { photoIntegrationActions, isPhotoIntegrationActionsLoading };
};

const useGetProjectIntegrationActions = () => {
  const { data, loading: isProjectIntegrationActionsLoading } = useQuery(
    GET_INTEGRATION_ACTIONS,
    {
      variables: { displayLocation: 'project-actions' },
    },
  );

  const projectIntegrationActions = data?.integrationActions ?? [];

  return { projectIntegrationActions, isProjectIntegrationActionsLoading };
};

export {
  useGetIntegrationActions,
  useGetPhotoIntegrationActions,
  useGetProjectIntegrationActions,
};
